/* eslint-disable react-hooks/exhaustive-deps */
import { useFoxTopUpStore } from "../store";
import { BindHangTags } from "@/components/top-up/types";
import { UserLevel } from "project-config/constants";
import { useGlobalStore } from "@/store/GlobalStore";
import { useEffect } from "react";
import { useQuery } from "react-query";

export function useFetchHangTags() {
  const { userInfo } = useGlobalStore();
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const activityInfoList = useFoxTopUpStore((state) => state.activityInfoList);
  const { data } = useQuery<BindHangTags[]>(
    "/api/rendering/user/queryPriceDiscount"
  );
  const fetchHangTags = async () => {
    if (!data || !userInfo) return;
    console.log("fox-queryPriceDiscount:::::", data);
    const res = data?.slice(1);
    const animationFreeze = [100, 500, 800, 1000];
    setFoxTopUpStore({
      HangTags: res.map((item, index) => ({
        ...item,
        animationNum: animationFreeze[index],
      })),
    });
    if (userInfo && userInfo.level !== UserLevel.Diamond) {
      setFoxTopUpStore({
        HangTags: res.filter((item) => userInfo.level < item.level),
      });
    }
  };

  useEffect(() => {
    fetchHangTags().catch(console.trace);
  }, [activityInfoList, userInfo, data]);

  return {};
}
